import React from 'react';
import { Button } from '../components/ui/Button';
import { BuildingIcon, BarChartIcon, UsersIcon, GlobeIcon, CheckIcon } from 'lucide-react';
export function RawfoundPropertiesPage() {
  return <div className="w-full" data-id="element-540">
      {/* Hero Section */}
      <section className="bg-black text-white py-24 relative" data-id="element-541">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-542">
          <img src="https://images.unsplash.com/photo-1564501049412-61c2a3083791?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="Luxury Hotel" className="w-full h-full object-cover opacity-40" data-id="element-543" />
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-544">
          <div className="max-w-3xl" data-id="element-545">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-546">
              Rawfound Properties
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-547">
              Specialized hospitality brokerage, consulting, and investor
              advisory services for the global hotel industry.
            </p>
            <Button href="/contact" size="lg" data-id="element-548">
              Contact Our Team
            </Button>
          </div>
        </div>
      </section>
      {/* Overview Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-549">
        <div className="container mx-auto px-4" data-id="element-550">
          <div className="max-w-4xl mx-auto" data-id="element-551">
            <div className="flex justify-center mb-12" data-id="element-552">
              <BuildingIcon className="h-20 w-20 text-black" data-id="element-553" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-8 text-center" data-id="element-554">
              Hospitality Industry Experts
            </h2>
            <p className="text-lg text-gray-600 mb-8 text-center" data-id="element-555">
              Rawfound Properties is a premier hospitality advisory firm
              specializing in hotel brokerage, investment advisory, and
              consulting services. We leverage our deep industry expertise and
              global network to deliver exceptional value to hotel owners,
              investors, and operators.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-556">
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-557">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-558">
                  <GlobeIcon className="h-8 w-8 text-black" data-id="element-559" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-560">
                  Global Reach
                </h3>
                <p className="text-gray-600" data-id="element-561">
                  Operating across key hospitality markets worldwide with a
                  focus on luxury and upscale properties.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-562">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-563">
                  <UsersIcon className="h-8 w-8 text-black" data-id="element-564" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-565">
                  Expert Team
                </h3>
                <p className="text-gray-600" data-id="element-566">
                  Industry veterans with decades of combined experience in hotel
                  operations, investment, and advisory.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-567">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-568">
                  <BarChartIcon className="h-8 w-8 text-black" data-id="element-569" />
                </div>
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-570">
                  Data-Driven
                </h3>
                <p className="text-gray-600" data-id="element-571">
                  Proprietary market intelligence and analytics to inform
                  strategic decisions and maximize returns.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-572">
        <div className="container mx-auto px-4" data-id="element-573">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-574">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-575">
              Our Services
            </h2>
            <p className="text-lg text-gray-600" data-id="element-576">
              Comprehensive hospitality solutions tailored to your specific
              needs and objectives.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-577">
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-578">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-579">
                Hotel Brokerage & Transactions
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-580">
                Expert representation for buyers and sellers of hotel assets,
                from single properties to portfolios. We handle every aspect of
                the transaction process to ensure smooth and successful
                closings.
              </p>
              <ul className="space-y-2" data-id="element-581">
                <li className="flex items-start" data-id="element-582">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-583" />
                  <span className="text-gray-600" data-id="element-584">
                    Buyer and seller representation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-585">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-586" />
                  <span className="text-gray-600" data-id="element-587">Portfolio transactions</span>
                </li>
                <li className="flex items-start" data-id="element-588">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-589" />
                  <span className="text-gray-600" data-id="element-590">
                    Joint venture structuring
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-591">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-592">
                Investment Advisory
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-593">
                Strategic guidance for investors seeking to enter or expand in
                the hospitality sector. We identify opportunities aligned with
                your investment criteria and help optimize returns.
              </p>
              <ul className="space-y-2" data-id="element-594">
                <li className="flex items-start" data-id="element-595">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-596" />
                  <span className="text-gray-600" data-id="element-597">
                    Opportunity identification
                  </span>
                </li>
                <li className="flex items-start" data-id="element-598">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-599" />
                  <span className="text-gray-600" data-id="element-600">
                    Investment strategy development
                  </span>
                </li>
                <li className="flex items-start" data-id="element-601">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-602" />
                  <span className="text-gray-600" data-id="element-603">Due diligence support</span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-604">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-605">
                Asset Management
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-606">
                Hands-on management of hotel assets to maximize operational
                performance, enhance value, and achieve investment objectives.
              </p>
              <ul className="space-y-2" data-id="element-607">
                <li className="flex items-start" data-id="element-608">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-609" />
                  <span className="text-gray-600" data-id="element-610">Operational oversight</span>
                </li>
                <li className="flex items-start" data-id="element-611">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-612" />
                  <span className="text-gray-600" data-id="element-613">Revenue optimization</span>
                </li>
                <li className="flex items-start" data-id="element-614">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-615" />
                  <span className="text-gray-600" data-id="element-616">
                    Capital expenditure planning
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-617">
              <h3 className="text-xl font-semibold text-black mb-4" data-id="element-618">
                Hospitality Consulting
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-619">
                Expert consulting services covering all aspects of hotel
                development, operations, and strategy to help clients overcome
                challenges and seize opportunities.
              </p>
              <ul className="space-y-2" data-id="element-620">
                <li className="flex items-start" data-id="element-621">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-622" />
                  <span className="text-gray-600" data-id="element-623">
                    Market analysis & feasibility studies
                  </span>
                </li>
                <li className="flex items-start" data-id="element-624">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-625" />
                  <span className="text-gray-600" data-id="element-626">Operator selection</span>
                </li>
                <li className="flex items-start" data-id="element-627">
                  <CheckIcon className="h-5 w-5 text-black mr-2 mt-0.5" data-id="element-628" />
                  <span className="text-gray-600" data-id="element-629">
                    Repositioning strategies
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Case Studies Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-630">
        <div className="container mx-auto px-4" data-id="element-631">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-632">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-633">
              Success Stories
            </h2>
            <p className="text-lg text-gray-600" data-id="element-634">
              A glimpse into how we've helped our clients achieve their
              hospitality investment objectives.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-635">
            <div className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-636">
              <div className="h-64 bg-gray-200" data-id="element-637">
                <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Luxury Hotel Portfolio" className="w-full h-full object-cover" data-id="element-638" />
              </div>
              <div className="p-8" data-id="element-639">
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-640">
                  Luxury Hotel Portfolio Acquisition in Dubai
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-641">
                  Advised a private equity firm on the acquisition of a 300M AED
                  portfolio of luxury hotels across Dubai, including due
                  diligence, valuation, and negotiations.
                </p>
                <p className="text-gray-600" data-id="element-642">
                  <strong data-id="element-643">Result:</strong> Successfully closed the transaction
                  below market valuation, with a strategic post-acquisition plan
                  that optimized operations and enhanced guest experience.
                </p>
              </div>
            </div>
            <div className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-644">
              <div className="h-64 bg-gray-200" data-id="element-645">
                <img src="https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Resort Repositioning" className="w-full h-full object-cover" data-id="element-646" />
              </div>
              <div className="p-8" data-id="element-647">
                <h3 className="text-xl font-semibold text-black mb-3" data-id="element-648">
                  Resort Repositioning Strategy
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-649">
                  Developed a comprehensive repositioning strategy for an
                  underperforming beachfront resort, including brand selection,
                  renovation planning, and marketing strategy.
                </p>
                <p className="text-gray-600" data-id="element-650">
                  <strong data-id="element-651">Result:</strong> RevPAR increase of 45% and ADR growth
                  of 60% within 12 months of reopening, establishing the
                  property as a market leader.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-black text-white" data-id="element-652">
        <div className="container mx-auto px-4 bg-pattern" data-id="element-653">
          <div className="max-w-4xl mx-auto text-center" data-id="element-654">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-655">
              Ready to Elevate Your Hospitality Investments?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-656">
              Contact our team of hospitality experts to discuss your specific
              needs and objectives. We're here to help you navigate the complex
              hospitality landscape and achieve exceptional results.
            </p>
            <Button href="/contact" size="lg" data-id="element-657">
              Contact Our Team
            </Button>
          </div>
        </div>
      </section>
    </div>;
}